<section class="hero-section" id="hero">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-7">

        <!-- <div class="welcome-message-container" data-animation="fade-in-up" data-animation-delay="1">
          <div class="ai-greeting" [class.loading]="isLoadingMessage">
            <div class="greeting-text" *ngIf="!isLoadingMessage">{{ welcomeMessage }}</div>
            <div class="greeting-loader" *ngIf="isLoadingMessage">
              <span class="dot-pulse"></span>
              <span>Generating personalized greeting...</span>
            </div>
            <button class="btn-personalize" (click)="toggleNameInput()" *ngIf="!isLoadingMessage">
              <i class="fas fa-magic"></i>
              <span>{{ userName ? 'Change' : 'Personalize' }}</span>
            </button>
          </div>
          <div class="name-input-container" *ngIf="showNameInput">
            <input #nameInput type="text" class="form-control name-input" placeholder="Enter your name" [value]="userName" (keyup.enter)="updateName(nameInput.value)">
            <button class="btn btn-sm btn-outline-light" (click)="updateName(nameInput.value)">Apply</button>
          </div>
        </div> -->
        <h1 class="heading-large" data-animation="fade-in-up" data-animation-delay="2">
          <div class="heading-line">
            <span class="text-white">Intelligent </span>
          </div>
          <div class="heading-line">
            <span class="blue-text">Test Automation</span>
          </div>
        </h1>
        <p class="hero-description" data-animation="fade-in-up" data-animation-delay="3">
          Quality-driven AI-powered automation testing platform offering exceptional user
          experience across functional (API, Web, Mobile & Desktop) and non-functional
          (Performance & Chaos) automation.
        </p>
        <div class="hero-buttons" data-animation="fade-in-up" data-animation-delay="4">
          <a (click)="videoModal(video)" class="btn btn-gradient-blue mr-3">Watch us Live</a>
          <ng-template #video let-modal>
            <div class="modal-body p-0">
              <video controls width="100%">
                <source src="/assets/help-videos/relay_teaser.mp4" type="video/mp4"> Your browser does not support
                HTML5 video.
              </video>
            </div>
          </ng-template>
          <!-- <a href="https://jira.corp.adobe.com/projects/RELAY/summary" class="btn btn-outline-light" target="_blank">Request Demo</a> -->
        </div>
        <div class="created-by mt-4" data-animation="fade-in-up" data-animation-delay="4">
          <small class="d-flex align-items-center">
            <span class="trust-badge mr-2">
              <i class="fas fa-shield-alt"></i>
            </span>
            Trusted by: Adobe Engineering Teams
          </small>
        </div>
      </div>
      <div class="col-lg-5 d-none d-lg-block">
        <div class="hero-image-container" data-animation="fade-in-left" data-animation-delay="2">
          <div class="code-effect">
            <div class="automation-keywords">
              <span class="keyword keyword-1">AI-Based Testdata Creation</span>
              <span class="keyword keyword-2">Prompt Based Automation</span>
              <span class="keyword keyword-3">Selenium & Playwright</span>
              <span class="keyword keyword-4">CI/CD Integration</span>
              <span class="keyword keyword-5">Self-Healing Tests</span>
              <span class="keyword keyword-6">Record & Generate tests</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="code-background"></div>
</section>
